import { createFileRoute } from '@tanstack/react-router'
import { SettingsPage } from '../components/pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/impostazioni/notifiche')({
  head: () => noIndexRouteHead('settingsNotifications', 'it'),
  component: () => <SettingsPage section="benachrichtigungen" />,
})
